<template>
  <div>
    <div class="searchDomain" v-if="config.search">
      <div style="display: flex; justify-content: space-between">
        <el-form :inline="true" size="small" :model="searchForm">
          <el-form-item
            v-for="item in config.search"
            :key="item.key"
            v-if="!item.hidden"
          >
            <template v-if="item.type == 'daterange'">
              <el-date-picker
                v-model="searchForm[item.key]"
                type="daterange"
                clearable
                range-separator="至"
                :start-placeholder="item.label"
                :end-placeholder="item.label"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
              >
              </el-date-picker>
            </template>
            <template v-if="item.type == 'quickDate'">
              <el-date-picker
                v-model="searchForm[item.key]"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                clearable
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </template>
            <template v-else-if="item.type == 'select'">
              <el-select
                v-model="searchForm[item.key]"
                :placeholder="'' + item.label"
                clearable
                :filterable="item.filterable !== false"
                :multiple="item.multiple"
                class="w150"
                @change="(val) => handleSelectChange(val, item)"
              >
                <el-option
                  v-for="list in item.options"
                  :key="list.value"
                  :label="list.label"
                  :value="list.value"
                >
                </el-option>
              </el-select>
            </template>
            <template v-else-if="item.type == 'input'">
              <el-input
                v-model="searchForm[item.key]"
                suffix-icon="el-icon-search"
                clearable
                class="w180"
                :placeholder="item.label"
              ></el-input>
            </template>
            <template v-else-if="item.type == 'inputNumber'">
              <el-input
                v-model="searchForm[item.key]"
                suffix-icon="el-icon-search"
                oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                clearable
                :placeholder="item.label"
              ></el-input>
            </template>
            <template v-else-if="item.type == 'treeselect'">
              <treeselect
                class="searchTreeSelect"
                :multiple="item.multiple"
                :options="item.options"
                :flat="item.multiple"
                :placeholder="'' + item.label"
                style="width: 200px"
                v-model="searchForm[item.key]"
              ></treeselect>
            </template>
            <template v-else-if="item.type == 'checkbox'">
              <el-checkbox v-model="searchForm[item.key]">
                {{ item.label }}
              </el-checkbox>
            </template>
          </el-form-item>
          <el-form-item>
            <slot name="customSearch"></slot>
          </el-form-item>
          <el-form-item
            ><el-button
              type="primary"
              icon="el-icon-search"
              @click="queryEvents(searchForm)"
              size="small"
              >查询</el-button
            ></el-form-item
          >
          <el-form-item>
            <slot name="otherOperations"></slot>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div>
      <slot name="additionalFeatures"></slot>
      <div class="table_footer" v-if="config.isPage2">
        <p class="table_footer_total">共{{ config.total }}项数据</p>
        <el-pagination
          background
          @size-change="handleSizeChange"
          :page-sizes="[10, 50, 100, 500]"
          @current-change="handleCurrentChange"
          :current-page.sync="config.searchParameters.page"
          :page-size="config.searchParameters.limit"
          :layout="config.layout ? config.layout : 'sizes,prev, pager, next'"
          :total="config.total"
        >
        </el-pagination>
      </div>
    </div>
    <div class="table" v-if="!config.table">
      <el-table
        header-cell-class-name="headerCellStyle"
        cell-class-name="cellStyle"
        :data="config.data"
        style="width: 100%"
        row-key="id"
        :height="config.height"
        resizable
        border
        @cell-click="cellClick"
        @sort-change="sortChange"
        v-loading="config.loading"
        :default-expand-all="false"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          v-if="config.check"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          v-for="item in config.column"
          :show-overflow-tooltip="!item.showOverflowTooltip ? true : false"
          :key="item.prop"
          :fixed="item.fixed ? item.fixed : null"
          :sortable="item.sortable == true ? 'custom' : false"
          :prop="item.prop"
          :label="item.label"
          :width="item.fixedWidth || null"
          :min-width="item.width ? item.width : 80"
          :align="item.align ? item.align : 'left'"
        >
          <template #header>
            <el-tooltip
              effect="dark"
              :content="item.label"
              placement="top-start"
            >
              <span> {{ item.label }}</span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <template v-if="item.slot">
              <slot :name="item.prop" :row="scope.row" />
            </template>
            <template v-else-if="item.filter">
              {{ scope.row[item.prop] | dynamicFilter(item.filter) }}
            </template>
            <template v-else-if="item.isMoney">
              {{ scope.row[item.prop] | money }}
            </template>
            <template v-else-if="item.type == 'img'">
              <template v-if="scope.row[item.prop]">
                <el-image
                  :src="scope.row[item.prop]"
                  style="width: 50px; height: 50px"
                ></el-image>
              </template>
              <template v-else>--</template>
            </template>
            <template v-else>
              {{
                scope.row[item.prop] || scope.row[item.prop] == 0
                  ? scope.row[item.prop]
                  : "--"
              }}
            </template>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          v-if="config.operation == false ? false : true"
          :width="config.operationWidth ? config.operationWidth : 350"
          fixed="right"
        >
          <template slot-scope="scope">
            <slot name="operation" :row="scope.row"></slot>
          </template>
        </el-table-column>
      </el-table>
      <div class="table_footer" v-if="config.isPage">
        <p class="table_footer_total">共{{ config.total }}项数据</p>
        <el-pagination
          background
          @size-change="handleSizeChange"
          :page-sizes="[10, 50, 100, 500]"
          @current-change="handleCurrentChange"
          :current-page.sync="config.searchParameters.page"
          :page-size="config.searchParameters.limit"
          :layout="config.layout ? config.layout : 'sizes,prev, pager, next'"
          :total="config.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { getRoles } from "@/utils";
export default {
  name: "basicList",
  components: { Treeselect },
  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    // 监听 searchForm.shop_id 的变化
    "searchForm.shop_id": function (newVal, oldVal) {
      // 当 shop_id 发生变化时，发射 update:shopId 事件
      this.$emit("ShopIdChange", newVal);
    },
    config: {
      handler(val) {
        if (val.search.length > 0) {
          val.search.map((item) => {
            if (item.value !== undefined && item.value !== '' && !(item.key in this.searchForm)) this.$set(this.searchForm, item.key, item.value);
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  filters: {
    dynamicFilter: function (value, name) {
      if (name == "isYes") {
        return value == 1 ? "是" : value == 0 ? "否" : "--";
      } else if (name == "storeType") {
        return value == 0 ? "门店" : value == 2 ? "仓库" : "--";
      } else if (name == "documentStatus") {
        return value == 0
          ? "正常"
          : value == 1
          ? "取消"
          : value == 2
          ? "取消"
          : value == 10
          ? "预售"
          : value == 3
          ? "退款退货"
          : value == 4
          ? "仅退货不退款"
          : "--";
      } else if (name == "storeStatus") {
        return value == 0 ? "启用" : value == 1 ? "禁用" : "--";
      } else if (name == "merchantStatus") {
        return value == 0 ? "启用" : value == 1 ? "禁用" : "--";
      } else if (name == "upAndDownShelves") {
        return value == 0 ? "上架" : value == 1 ? "下架" : "--";
      } else if (name == "sellOrStopSell") {
        return value == 1 ? "在售" : value == 2 ? "停售" : "--";
      } else if (name == "invoiceStatus") {
        return value == 1 ? "含票" : value == 0 ? "未税" : "--";
      } else if (name == "transType") {
        return value == 1 ? "包邮" : value == 0 ? "自提" : "--";
      } else if (name == "supplyLevel") {
        return value == 1
          ? "正常"
          : value == 2
          ? "贷款"
          : value == 3
          ? "品牌垫付"
          : "--";
      } else if (name == "typeText") {
        return value == 1
          ? "分享"
          : value == 2
          ? "大客户"
          : value == 3
          ? "VIP"
          : value == 4
          ? "散客"
          : "--";
      } else if (name == "customerClassification") {
        return value == 1
          ? "同行"
          : value == 2
          ? "分销"
          : value == 3
          ? "团购"
          : value == 4
          ? "外卖"
          : "零售(POS)";
      } else if (name == "takeState") {
        return value == 0
          ? "正常"
          : value == 1
          ? "锁定"
          : value == 2
          ? "撤销"
          : value == 3
          ? "刷单"
          : value == 4
          ? "跳过"
          : "--";
      } else if (name == "orderStatus") {
        return value == 0
          ? "未创建交易"
          : value == 1
          ? "等待付款"
          : value == 2
          ? "等待发货"
          : value == 3
          ? "已完成"
          : value == 4
          ? "已关闭"
          : value == 5
          ? "已发货等待确认"
          : value == 6
          ? "已签收"
          : "--";
      } else if (name == "deliveryStatus") {
        return value == 10
          ? "待接单"
          : value == 20
          ? "已接单待取货"
          : value == 30
          ? "已到店"
          : value == 40
          ? "配送中"
          : value == 50
          ? "已完成"
          : value == 60
          ? "已取消"
          : value == 70
          ? "配送失败"
          : "--";
      } else if (name == "sellStatus") {
        return value == 0 ? "在售" : value == 1 ? "停售" : "--";
      } else if (name == "adjustmentStatus") {
        return value == 0
          ? "待入库"
          : value == 1
          ? "已完成"
          : value == 2
          ? "撤销"
          : value == 3
          ? "待出库"
          : value == 4
          ? "待审核"
          : "--";
      } else if (name == "orderType") {
        return value == 7
          ? "美团"
          : value == 8
          ? "饿百"
          : value == 9
          ? "京东"
          : value == 6
          ? "POS机"
          : "--";
      } else if (name == "supplierLevel") {
        return value == 0
          ? "普通"
          : value == 4
          ? "散户"
          : value == 1
          ? "特殊"
          : "-";
      } else if (name == "wechatStatus") {
        return value == 0 ? "启用" : "禁用";
      } else if (name == "is_auto_push") {
        return value == 0 ? "关闭" : value == 1 ? "开启" : "--";
      }
    },
  },
  data() {
    return {
      searchForm: {
        shop_id: null,
        type_id: null,
        time: [],
        create_time: [],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "本周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    console.log(
      "%c [  ]-414",
      "font-size:13px; background:pink; color:#bf2c9f;",
      JSON.parse(getRoles()).role_id
    );
    if (
      (JSON.parse(getRoles()).role_id == 1 ||
        JSON.parse(getRoles()).role_id == 2 ||
        JSON.parse(getRoles()).role_id == 3) &&
      (this.$route.name == "productShelfLife" ||
        this.$route.name == "takeoutanalysis")
    ) {
      this.searchForm.shop_id = JSON.parse(getRoles()).shop_id;
    }
  },
  created() {
    // 当角色=4时，门店默认主门店
    if (JSON.parse(getRoles()).role_id == 4) {
      this.searchForm.shop_id = JSON.parse(getRoles()).shop_id;
    }
  },
  methods: {
    // 处理下拉框选择变化
    handleSelectChange(value, item) {
      // 如果表单项有 change 回调，执行它
      if (item && item.change) {
        item.change(value);
      }
    },
    cellClick(row, column, cell, event) {
      this.$emit("cellClick", row, column, cell, event);
    },
    // 排序
    sortChange(column) {
      this.$emit("sortChange", column);
    },
    // 给搜索组件赋值
    searchComponentAssignment(data) {
      this.searchForm = data;
    },
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    dynamicEventTransmission(val) {
      this.$emit("dynamic", val);
    },
    queryEvents(data) {
      for (let key in data) {
        if (data[key] && typeof data[key] === "string") {
          data[key] = data[key].trim();
        }
      }
      this.$emit("search", data);
    },
    handleSizeChange(val) {
      // this.$emit("handleSizeChange", val);
      this.$emit("search", this.searchForm, "", val);
    },
    handleCurrentChange(val) {
      this.$emit("search", this.searchForm, val, "");
    },
  },
};
</script>

<style scoped>
/deep/.searchDomain .w180 .el-input__inner {
  width: 180px;
}
</style>



// WEBPACK FOOTER //
// src/components/basicList/index.vue